import React, { Component } from "react";

import { connect } from "react-redux";
import ChoiceGridScroll from "../Choices/ChoiceGridScroll";
import ScrollContainer from "react-indiana-drag-scroll";
import NavigateBeforeIcon from "@material-ui/icons/NavigateBefore";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import ProductOptionGroup from "../Groups/";

class OptionGroupScroll extends Component {
  state = { isScrollable: false, updated: false };
  handleResize = () => {
    if (this.container.current) {
      let CheckScrollAble =
        this.container.current.container.current.scrollWidth >
        this.container.current.container.current.clientWidth;

      if (CheckScrollAble !== this.state.isScrollable) {
        this.setState({
          isScrollable: CheckScrollAble,
        });
        return;
      }
    }
    this.setState({});
  };
  componentDidMount = () => {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("orientationchange", this.handleResize, true);
  };
  componentDidUpdate = () => {
    if (!this.state.updated) {
      this.handleResize();
      this.setState({ updated: true });
    }
  };
  componentWillUnmount = () => {
    window.removeEventListener("resize", this.handleResize);
    window.removeEventListener("orientationchange", this.handleResize, true);
  };
  ScrollContainer = (scrollingAmount) => {
    this.container.current.container.current.scrollLeft += scrollingAmount;
  };
  container = React.createRef();

  render() {
    const {
      option,
      selectedOptions,
      controlOptions,
      themeColor,
      language,
      discountAmount,
      productQuantity,
      productUsedComponents,
      editedProduct,
      groupID,
      optionKey,
    } = this.props;

    const { isScrollable } = this.state;
    const containerWidth =
      this.container?.current?.container?.current?.clientWidth || 200;
    const choices = option.choices.map((choice) => (
      <ChoiceGridScroll
        key={`${optionKey} ${choice.id}`}
        themeColor={themeColor}
        choice={{ ...choice }}
        option={option}
        selectedOptions={selectedOptions}
        controlOptions={controlOptions}
        containerWidth={containerWidth}
        discountAmount={discountAmount}
        productQuantity={productQuantity}
        productUsedComponents={productUsedComponents}
        editedProduct={editedProduct}
        groupID={groupID}
        optionKey={optionKey}
      />
    ));
    const conditionalChoices = option.choices.map((choice) => {
      const isChoiceSelected = this.props.checkChoiceSelected(
        choice.id,
        choice.option,
        groupID ?? groupID
      );
      const conditionalOptions = this.props.getConditionalOptions(
        choice.id,
        choice.option
      );
      return (
        <div className={` ${isChoiceSelected ? "" : "hidden"}`}>
          {conditionalOptions?.map((op) => (
            <div key={op.id}>
              <ProductOptionGroup
                key={op.id}
                option={op}
                controlOptions={controlOptions}
                selectedOptions={selectedOptions}
                themeColor={themeColor}
                discountAmount={discountAmount}
                productQuantity={productQuantity}
                productUsedComponents={productUsedComponents}
                editedProduct={editedProduct}
                editMode={this.props.editMode}
                inInGroup={false}
                sortOrder={op.sort_order}
              />
            </div>
          ))}
        </div>
      );
    });
    this.choices = choices;
    return (
      <>
        <div className="d-flex pb-3  align-items-center">
          {isScrollable && (
            <NavigateBeforeIcon
              style={{ marginBottom: "55px", fontSize: "30px" }}
              className="pointer"
              onClick={() => this.ScrollContainer(-100)}
            />
          )}
          <ScrollContainer
            vertical={false}
            style={{
              justifyContent:
                (isScrollable && "space-between") || "space-evenly",
              flexDirection: language === "arabic" && "row-reverse",
            }}
            className="mt-3 d-flex  option-scroll-parent w-100"
            ref={this.container}
          >
            {choices}
          </ScrollContainer>
          {isScrollable && (
            <NavigateNextIcon
              style={{ marginBottom: "55px", fontSize: "30px" }}
              className=" pointer"
              onClick={() => this.ScrollContainer(100)}
            />
          )}
        </div>
        <div>{conditionalChoices}</div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return { language: state.store.language };
};

export default connect(mapStateToProps)(OptionGroupScroll);
